import { jwtDecode } from 'jwt-decode';

export function decodeJwt(token) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function extractDepts(token) {
  const claims = decodeJwt(token);
  if (!claims) return [];
  const raw = claims.depts ?? claims.departments ?? claims.department ?? [];
  return Array.isArray(raw) ? raw.map(String) : [String(raw)];
}

export function extractSubject(token) {
  const claims = decodeJwt(token);
  return claims?.sub || null;
}

export function isTokenExpired(token) {
  const claims = decodeJwt(token);
  if (!claims || !claims.exp) return true;
  return (claims.exp * 1000) < Date.now();
}
